import { render, staticRenderFns } from "./ScheduleAppointmentCard.vue?vue&type=template&id=5ccf7a31&scoped=true&"
import script from "./ScheduleAppointmentCard.vue?vue&type=script&lang=ts&"
export * from "./ScheduleAppointmentCard.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleAppointmentCard.vue?vue&type=style&index=0&id=5ccf7a31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf7a31",
  null
  
)

export default component.exports